import styled from 'styled-components';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/material.css';
import {
  baseFontFamily,
  fontSize,
} from '@tphglobal/common/theme/style.typography';
import {
  brand,
  greyScaleColour,
  otherColour,
} from '@tphglobal/common/theme/style.palette';
export const StyledPhoneInput = styled(PhoneInput)<{
  hasError?: boolean;
  isDisabled?: boolean;
  position?: string;
  bgColor?: string;
}>`
  &.react-tel-input .form-control {
    width: 100%;
    font-family: ${baseFontFamily};
    font-size: ${fontSize.b1};
    padding: 15.5px 14px 15.5px 58px;
    border-radius: 8px !important;
    border-color: ${({ hasError }) => hasError && otherColour.errorDefault};
    &:focus {
      border-color: ${greyScaleColour.grey100} !important;
      box-shadow: none !important;
    }
    color: ${({ isDisabled }) =>
      isDisabled ? `${greyScaleColour.grey90} !important` : 'inherit'};
  }
  &.react-tel-input .special-label {
    font-family: ${baseFontFamily};
    font-size: ${fontSize.b3};
    left: 10px;
    color: ${greyScaleColour.grey90};
    background-color: ${({ bgColor }) => bgColor || brand.white} !important;
    transition: color 0.2s ease;
  }
  &.react-tel-input:focus-within .special-label {
    color: ${greyScaleColour.grey100} !important;
  }
  &.react-tel-input:not(:focus-within):has(.form-control:hover) .special-label {
    color: ${brand.black} !important;
  }
  &.react-tel-input {
    font-family: ${baseFontFamily};
    font-size: ${fontSize.b1};
  }
  &.react-tel-input .selected-flag:focus .arrow {
    border-left: 3px solid transparent;
    border-right: 3px solid transparent;
  }
  &.react-tel-input .country-list {
    z-index: 1000;
    position: absolute;
    top: 100%;
    left: 0;
    box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2);
    width: 240px;
  }

  /* Disable hover changes on text + border */
  ${({ isDisabled }) =>
    isDisabled &&
    `
    & .form-control:hover {
      border-color: ${greyScaleColour.grey70} !important;
      color: ${greyScaleColour.grey90} !important;
      cursor: not-allowed !important;
    }
  `}

  /* Disable focus highlight */
  ${({ isDisabled }) =>
    isDisabled &&
    `
    & .form-control:focus {
      border-color: ${greyScaleColour.grey70} !important;
      box-shadow: none !important;
      color: ${greyScaleColour.grey90} !important;
    }
  `}

  /* Disable country dropdown */
  ${({ isDisabled }) =>
    isDisabled &&
    `
    & .flag-dropdown {
      pointer-events: none !important;
      cursor: not-allowed !important;
    }

    & .selected-flag:hover {
      background-color: transparent !important;
      cursor: not-allowed !important;
    }
  `}

  /* Keep label grey even on hover */
  ${({ isDisabled }) =>
    isDisabled &&
    `
    & .special-label {
      color: ${greyScaleColour.grey80} !important;
    }

    & .form-control:hover ~ .special-label {
      color: ${greyScaleColour.grey80} !important;
    }

    &.react-tel-input:not(:focus-within):has(.form-control:hover) .special-label {
      color: ${greyScaleColour.grey80} !important;
    }
  `}
`;

export const StyledPhoneInputContainer = styled.div<{
  isDisabled?: boolean;
}>`
  display: flex;
  flex-direction: column;
  width: 100%;
  position: relative;

  ${({ isDisabled }) =>
    isDisabled &&
    `
    pointer-events: none;
    opacity: 1;
  `}
`;